import React, {Component} from 'react';

export default class Header extends Component {
    render() {
        return (
            <header>
                <div className="header__content">
                    <a href="https://gormedosmotr.ru">
                        <img src="/assets/images/med_logo.png"/>
                    </a>
                    <span>Новосибирск, Вокзальная магистраль 1/1</span>
                    <span>+7 (383) 328-01-03, 209-03-01</span>
                </div>
            </header>
        )
    }
}



// WEBPACK FOOTER //
// frontend/src/modules/template/Header.jsx